export const DEFAULTS = {
  color: '#59a2ff',
  initialPosition: 0.08,
  height: 4,
  easing: 'ease',
  speed: 200,
  zIndex: 2147483647,
  showSpinner: false,
  boxShadow: undefined,
};

export const START_LOADER_EVENT = 'loader-progress-start';
export const STOP_LOADER_EVENT = 'loader-progress-stop';
